/* Chill Out — dropdown menus (co-menu). One open group per menu. */
(function () {
  if (window.__coMenuReady) return;
  window.__coMenuReady = true;

  function setOpen(btn, open) {
    var sub = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var item = btn.closest('.co-menu__item');
    if (item) item.classList.toggle('is-open', open);
    if (sub) {
      if (open) sub.removeAttribute('hidden');
      else sub.setAttribute('hidden', '');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.co-menu__toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var open = btn.getAttribute('aria-expanded') !== 'true';
    var menu = btn.closest('[data-co-menu]');
    if (open && menu) {
      menu.querySelectorAll('.co-menu__toggle[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) setOpen(other, false);
      });
    }
    setOpen(btn, open);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sub = e.target.closest && e.target.closest('.co-menu__sub');
    var item = e.target.closest && e.target.closest('.co-menu__item--parent');
    if (!item) return;
    var btn = item.querySelector('.co-menu__toggle');
    if (btn && btn.getAttribute('aria-expanded') === 'true') {
      setOpen(btn, false);
      if (sub) btn.focus();
    }
  });
})();
